import axios from 'axios';

export default {
  getAccounts (sortBy = 'lastModifiedDate', sortDesc = [true], page = 0, itemsPerPage = 10) {
    if (sortBy.length === 0) {
      sortBy = 'lastModifiedDate';
    }

    if (sortDesc.length === 0) {
      sortDesc[0] = true;
    }
    const sortType = sortDesc[0] ? 'desc' : 'asc';

    const url = `${process.env.VUE_APP_RAISON_API_URL}accounts?sort=${sortBy},${sortType}&page=${page}&pageSize=${itemsPerPage}`;
    return axios.get(url);
  },

  createAccount (account) {
    return axios.post(`${process.env.VUE_APP_RAISON_API_URL}accounts`, account);
  },

  getAccount (accountId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}accounts/${accountId}`);
  },

  getAccountMembers (accountId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}accounts/${accountId}/members`);
  },

  getAccountProjects (accountId) {
    return axios.get(`${process.env.VUE_APP_RAISON_API_URL}accounts/${accountId}/projects`);
  },

  saveAccount (account) {
    if(!account.id) {
      return this.createAccount(account);
    }
    else {
      return axios.put(`${process.env.VUE_APP_RAISON_API_URL}accounts/${account.id}`, account);
    }
  },
};